import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllWoongarantInsurancesCommand } from "@/app/woongarant-insurance/commands/get-all-woongarant-insurances.command"
import { WoongarantDownloadDocumentCommand } from "@/app/woongarant-insurance/commands/woongarant-download-document.command"

const httpClient = new AxiosClient()

export const getAllWoongarantInsurancesCommand = new GetAllWoongarantInsurancesCommand(httpClient, store)
export const woongarantDownloadDocumentCommand = new WoongarantDownloadDocumentCommand(httpClient, store)
